var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('calendarBreadcrumbs',{attrs:{"link":'dashboardPublish'}}),_c('h3',{staticClass:"flix-html-h3"},[_vm._v(_vm._s(_vm.$t('message.embedCode', 1)))]),_c('transition',{attrs:{"name":"flixFadeIn"}},[_c('div',{key:_vm.updateKey},[(_vm.$route.params.id !== 'all')?_c('calendarEmbed',{attrs:{"id":_vm.$route.params.id}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }